import { ReadonlyRecord } from '@bimser/core';
import { List, Record } from 'immutable';
import { FormsContent, FormsContentFactoryFromJS, IFormsContent } from './IForms';
import {
	IInheritContent,
	InheritContent,
	InheritContentFactoryFromJS,
	InheritFactory
} from './IInherit';
import { IProfilesContent, ProfilesContent, ProfilesContentFactoryFromJS } from './IProfiles';
import { IProjectContent, ProjectContent, ProjectContentFactoryFromJS } from './IProject';

export interface IBaseMetaData {
	inherited: boolean;
}

export interface IMetaDataContent extends IBaseMetaData {
	projects: Array<IProjectContent>;
	forms: Array<IFormsContent>;
	value: {
		fields: Array<string>;
		profiles: Array<IProfilesContent>;
	};
	why: IInheritContent;
}

export interface IReadonlyMetaData extends IBaseMetaData {
	projects: List<ProjectContent>;
	forms: List<FormsContent>;
	value: {
		fields: List<string>;
		profiles: List<ProfilesContent>;
	};
	why: InheritContent;
}

export type MetaDataContent = ReadonlyRecord<IReadonlyMetaData>;

export const MetaDataFactory = Record<IReadonlyMetaData>({
	inherited: false,
	projects: List<ProjectContent>(),
	forms: List<FormsContent>(),
	value: {
		fields: List(),
		profiles: List<ProfilesContent>()
	},
	why: InheritFactory()
});

export const MetaDataContentFactoryFromJS = function (data: IMetaDataContent) {
	const _projects: Array<ProjectContent> =
		data?.projects.map(d => ProjectContentFactoryFromJS(d)) || [];

	const _forms: Array<FormsContent> = data?.forms.map(d => FormsContentFactoryFromJS(d)) || [];

	const _profiles: Array<ProfilesContent> =
		data?.value?.profiles.map(d => ProfilesContentFactoryFromJS(d)) || [];

	return MetaDataFactory({
		inherited: data.inherited,
		projects: List(_projects),
		forms: List(_forms),
		value: {
			fields: List<string>(data.value.fields),
			profiles: List(_profiles)
		},
		why: InheritContentFactoryFromJS(data.why)
	});
};
